export default __webpack_public_path__ + "static/media/logo.b44ee7f8.png";